import { useState, useEffect } from 'react';
import { Table, DatePicker, Select, Button, Modal, Form, Input, Tag } from 'antd';
import {downloadExcel, getData} from '../api/api';
import { FileExcelOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
const { RangePicker } = DatePicker;

const TransactionQrs = () => {
    const [data, setData] = useState([]);
    const [partners, setPartners] = useState([]);
    const [merchants, setMerchants] = useState([]);
    const [bankAccounts, setBankAccounts] = useState([]);
    const [terminals, setTerminals] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [totalServiceFee, setTotalServiceFee] = useState(0);
    const [totalRubAmount, setTotalRubAmount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
    const [filters, setFilters] = useState({
        fromDate: dayjs().format('DD.MM.YYYY'), // Default bugungi sana
        toDate: dayjs().format('DD.MM.YYYY'), // Default bugungi sana
    });
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [form] = Form.useForm();

    const isTransactionPage = window.location.pathname === '/transactions';

    const columns = [
        {
            title: '№',
            key: 'index',
            width: 60,
            render: (_, __, index) => index + 1 + (pagination.current - 1) * pagination.pageSize,
        },
        { title: 'Partner nomi', dataIndex: 'partnerName', key: 'partnerName', width: 150 },
        { title: 'Partner bank', dataIndex: 'partnerBank', key: 'partnerBank', width: 150 },
        { title: 'Terminal nomi', dataIndex: 'terminalName', key: 'terminalName', width: 150 },

        {
            title: 'Summa',
            dataIndex: 'amount',
            key: 'amount',
            width: 250,
            render: (amount) => <p>{(amount / 100).toLocaleString()}  so'm</p>,
        },

        {
            title: 'Rate',
            dataIndex: 'rate',
            key: 'rate',
            width: 100,
            render: (rate, record) => record.currencyCode === 'UZS' ? '-' : <p>{rate}</p>,
        },

        {
            title: 'RUBL dagi qiymati',
            dataIndex: 'currencyAmount',
            key: 'currencyAmount',
            width: 250,
            render: (currencyAmount, record) => record.currencyCode === 'UZS' ? '-' : <p>{(currencyAmount / 100).toLocaleString()} {record.currencyCode}</p>,
        },
        {
            title: "Service fee",
            dataIndex: 'serviceFeeAmount',
            key: 'serviceFeeAmount',
            width: 250,
            render: (serviceFeeAmount) => <p>{serviceFeeAmount ? (serviceFeeAmount / 100).toLocaleString() + ` so'm` : '-'}</p>,
        },
        {
            title: 'Holati',
            dataIndex: 'statusCode',
            key: 'statusCode',
            width: 150,
            render: (status, record) =>
                <Tag color={status===50 ? "green" : status===20 ? "red" : status===0 ? "blue" : status===5 ? "orange" : status===10 ? "blue" : "gold"} >{record.statusName}</Tag>
        },
        { title: 'Yaratilgan vaqti', dataIndex: 'createdAt', key: 'createdAt', width: 180 },
        { title: "O'zgartirilgan vaqti", dataIndex: 'updatedAt', key: 'updatedAt', width: 180 },
        {
            title: 'Merchantga  to\'lov holati',
            dataIndex: 'distributionStatus',
            key: 'distributionStatus',
            width: 200,
            render: (distributionStatus) => (
                <Tag color={distributionStatus === 50 ? 'green' : 'red'} >
                    {distributionStatus === 50 ? 'Pul chiqib ketgan' : 'Pul chiqmagan'}
                </Tag>
            ),
        }
    ];

    if (!isTransactionPage){
        columns.push(
            { title: 'Terminal turi', dataIndex: 'terminalType', key: 'terminalType', width: 150 },
            { title: 'Merchant nomi', dataIndex: 'merchantName', key: 'merchantName', width: 250 },
            { title: 'Bank akkount  nomi', dataIndex: 'bankAccountName', key: 'bankAccountName', width: 150 },
            { title: 'Link', dataIndex: 'link', key: 'link', width: 200 },
            { title: 'Redirect URL', dataIndex: 'redirectUrl', key: 'redirectUrl', width: 200 },
            { title: 'ID', dataIndex: 'id', key: 'id', width: 150 },
            { title: 'EXT ID', dataIndex: 'extId', key: 'extId', width: 200 }
        )
    }

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await getData('/admin/transaction-qr-list-by-filter', {
                page: pagination.current - 1,
                size: pagination.pageSize,
                status: -1,
                ...filters,
            });
            setData(response.data?.data?.content || []);
            setTotalAmount(response.data?.data?.details?.totalAmount || 0);
            setTotalServiceFee(response.data?.data?.details?.totalServiceFeeAmount || 0);
            setTotalRubAmount(response.data?.data?.details?.totalRubAmount || 0);

            setPagination({
                ...pagination,
                total: response.data?.data?.totalCount,
            });
        } catch (error) {
            console.error(error);
        }
        setLoading(false);
    };

    const getPartners = async () => {
        try {
            const response = await getData('/admin/partner-list-by-filter', {
                page: 0,
                size: 100000, // Keyinchalik yangi API chiqadi
                status: -1,
            });
            setPartners(response.data?.data?.content || []);
        } catch (error) {
            console.error(error);
        }
    };

    const getMerchants = async () => {
        const pId = filters.partnerId;
        if (pId) {
            try {
                const response = await getData('/admin/merchants-list-by-filter', {
                    page: 0,
                    size: 1000000, // Keyinchalik yangi API chiqadi
                    status: -1,
                    partnerId: pId,
                });
                setMerchants(response.data?.data?.content || []);
            } catch (error) {
                console.error(error);
            }
        } else {
            setMerchants([]); // PartnerId yo'q bo'lsa, merchantsni tozalash
        }
    };

    const getBankAccounts = async () => {
        const pId = filters.partnerId;
        if (pId) {
            try {
                const response = await getData('/admin/bank-account-list-by-filter', {
                    page: 0,
                    size: 10000000, // Keyinchalik yangi API chiqadi
                    status: -1,
                    partnerId: pId,
                });
                setBankAccounts(response.data?.data?.content || []);
            } catch (error) {
                console.error(error);
            }
        } else {
            setBankAccounts([]); // partnerId yo'q bo'lsa, accountni tozalash
        }
    };


    const getTerminals = async () => {
        const partnerId = filters.partnerId;
        const merchantId = filters.merchantId;
        if (partnerId && merchantId) {
            try {
                const response = await getData('/admin/terminal-list-by-filter', {
                    page: 0,
                    size: 10000000, // Keyinchalik yangi API chiqadi
                    status: -1,
                    partnerId: partnerId,
                    merchantId: merchantId
                });
                setTerminals(response.data?.data?.content || []);
            } catch (error) {
                console.error(error);
            }
        } else {
            setTerminals([]); // PartnerId yo'q bo'lsa, merchantsni tozalash
        }
    };

    const handleDownload = async () => {
        setDownloadLoading(true);
        try {
            await downloadExcel(
                '/admin/transaction-qr-download-excel-by-filter',
                {
                    status: -1,
                    ...filters,
                },
                'dinamikQrs.xlsx'
            );

        } catch (error) {
        } finally {
            setDownloadLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
        if (!partners || partners.length === 0) {
            getPartners();
        }
    }, [pagination.current, pagination.pageSize, filters]);

    // PartnerId o'zgarganda merchantsni yangilash uchun alohida useEffect
    useEffect(() => {
        getMerchants();
        getBankAccounts();
    }, [filters.partnerId]);

    // PartnerId yoki merchnatid o'zgarganda merchantsni yangilash uchun alohida useEffect
    useEffect(() => {
        getTerminals();
    }, [filters.partnerId, filters.merchantId]);

    const handleTableChange = (newPagination) => {
        setPagination(newPagination);
    };

    const handleFilter = (values) => {
        setFilters(values);
        setPagination({ ...pagination, current: 1 });
    };

    const handleCreate = async (values) => {
        // await createData('/dashboard', values);
        // fetchData();
        // setIsModalVisible(false);
        // form.resetFields();
    };

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        form.resetFields();
    };

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                <h2 style={{ margin: 0 }}>Dinamik QRlar</h2>
                {/*<Button type="primary" onClick={showModal}>*/}
                {/*    Dinamik QR qo'shish*/}
                {/*</Button>*/}

                <Button
                    type="primary"
                    icon={<FileExcelOutlined />}
                    onClick={handleDownload}
                    loading={downloadLoading}
                >
                    Excel yuklash
                </Button>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 16 }}>
                <RangePicker
                    allowSingleDateInRange
                    value={[
                        filters.fromDate ? dayjs(filters.fromDate, 'DD.MM.YYYY') : null,
                        filters.toDate   ? dayjs(filters.toDate,   'DD.MM.YYYY') : null,
                    ]}
                    format="DD.MM.YYYY"
                    size="middle"
                    onChange={(dates) => {
                        if (dates) {
                            const [start, end] = dates;
                            handleFilter({
                                ...filters,
                                fromDate: start?.format('DD.MM.YYYY'),
                                toDate:   (end ?? start)?.format('DD.MM.YYYY'),
                            });
                        }
                    }}
                />

                <Select
                    style={{ width: 200 }}
                    defaultValue={null}
                    onChange={(value) => handleFilter({ ...filters, partnerId: value })}
                    size="middle"
                    placeholder="Partner tanlang"
                    showSearch
                    filterOption={(input, option) =>
                        option?.children?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                    notFoundContent={'Not found'}
                    dropdownStyle={{ zIndex: 9999 }}
                    getPopupContainer={(trigger) => trigger.parentNode}
                >
                    <Select.Option value={null}>Barcha partnerlar</Select.Option>
                    {partners?.map((value) => (
                        <Select.Option key={value.id} value={value.id}>
                            {value.name}
                        </Select.Option>
                    ))}
                </Select>
                <Select
                    style={{ width: 200 }}
                    defaultValue={null}
                    onChange={(value) => handleFilter({ ...filters, merchantId: value })}
                    size="middle"
                    placeholder="Merchant tanlang"
                    disabled={!filters.partnerId} // Partner tanlanmasa disable qilinadi
                    showSearch
                    filterOption={(input, option) =>
                        option?.children?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                    notFoundContent={'Not found'}
                    dropdownStyle={{ zIndex: 9999 }}
                    getPopupContainer={(trigger) => trigger.parentNode}
                >
                    <Select.Option value={null}>Barcha merchantlar</Select.Option>
                    {merchants?.map((value) => (
                        <Select.Option key={value.id} value={value.id}>
                            {value.name}
                        </Select.Option>
                    ))}
                </Select>

                <Select
                    style={{ width: 200 }}
                    defaultValue={null}
                    onChange={(value) => handleFilter({ ...filters, terminalId: value })}
                    size="middle"
                    placeholder="Terminal tanlang"
                    disabled={!(filters.partnerId && filters.merchantId)} // Partner va merchant tanlanmasa disable qilinadi
                    showSearch
                    filterOption={(input, option) =>
                        option?.children?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                    notFoundContent={'Not found'}
                    dropdownStyle={{ zIndex: 9999 }}
                    getPopupContainer={(trigger) => trigger.parentNode}
                >
                    <Select.Option value={null}>Barcha terminallar</Select.Option>
                    {terminals?.map((value) => (
                        <Select.Option key={value.id} value={value.id}>
                            {value.name}
                        </Select.Option>
                    ))}
                </Select>

                <Select
                    style={{ width: 200 }}
                    defaultValue={null}
                    onChange={(value) => handleFilter({ ...filters, bankAccountId: value })}
                    size="middle"
                    placeholder="Hisob raqam tanlang"
                    disabled={!filters.partnerId} // Partner tanlanmasa disable qilinadi
                    showSearch
                    filterOption={(input, option) =>
                        option?.children?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                    notFoundContent={'Not found'}
                    dropdownStyle={{ zIndex: 9999 }}
                    getPopupContainer={(trigger) => trigger.parentNode}
                >
                    <Select.Option value={null}>Barcha Hisob raqamlar</Select.Option>
                    {bankAccounts?.map((value) => (
                        <Select.Option key={value.id} value={value.id}>
                            {value.name}
                        </Select.Option>
                    ))}
                </Select>

                <Select
                    style={{ width: 200 }}
                    defaultValue={null}
                    onChange={(value) => handleFilter({ ...filters, status: value })}
                    size="middle"
                    placeholder="Holatni tanlang"
                >
                    <Select.Option value={-1}>Barcha holatlar</Select.Option>
                    <Select.Option value={50}>Muvafiqayatli</Select.Option>
                    <Select.Option value={20}>Bekor qilingan</Select.Option>
                    <Select.Option value={10}>Jarayonda</Select.Option>
                    <Select.Option value={5}>Muddati tugagan</Select.Option>
                    <Select.Option value={0}>Yaratildi</Select.Option>
                </Select>
            </div>
            <Table
                columns={columns}
                dataSource={data}
                pagination={{
                    ...pagination,
                    showTotal: (total) => `Jami: ${total} ta`,
                }}
                loading={loading}
                onChange={handleTableChange}
                rowKey="id"
                scroll={{ x: 'max-content' }} // Gorizontal scroll uchun
                summary={() => (
                    <Table.Summary>
                        <Table.Summary.Row style={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>
                            <Table.Summary.Cell index={0}>
                                <strong>Jami: </strong>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={1}>
                                <strong>-</strong>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={2}>
                                <strong>-</strong>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={3}>
                                <strong>{(totalAmount / 100).toLocaleString()}  so'm</strong>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={4}>
                                <strong>-</strong>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={5}>
                                <strong>{(totalRubAmount / 100).toLocaleString()} RUB</strong>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={6}>
                                <strong>{(totalServiceFee / 100).toLocaleString()} so'm</strong>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={7} colSpan={7}></Table.Summary.Cell>
                        </Table.Summary.Row>
                    </Table.Summary>
                )}
            />
            <Modal
                title="Ma'lumot qo'shish"
                visible={isModalVisible}
                onCancel={handleCancel}
                footer={null}
            >
                <Form form={form} onFinish={handleCreate} layout="vertical">
                    <Form.Item
                        name="name"
                        label="Nomi"
                        rules={[{ required: true, message: "Iltimos, nomini kiriting!" }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Qo'shish
                        </Button>
                        <Button style={{ marginLeft: 8 }} onClick={handleCancel}>
                            Bekor qilish
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default TransactionQrs;